<div id="{{id}}" class="modal modal-lg fade" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-center" [innerHTML]="title | translate"></h4>
        <button type="button" class="ttp-btn-close" (click)="reset()" data-bs-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
      </div>
      <div class="modal-body">
        @if (option === 0) {
          <div>
            @if (optionOneText) {
              <p>
                <span [innerHTML]="optionOneText | translate"></span>
                <span><a [innerHTML]="optionOneLink | translate" (click)="setOption(1)" tabindex="0" (keyup.enter)="setOption(1)" href="javascript:void(0)"></a></span>
              </p>
            }
            @if (optionTwoText) {
              <p>
                <span [innerHTML]="optionTwoText | translate"></span>
                <span><a [innerHTML]="optionTwoLink | translate" (click)="setOption(2)" href="javascript:void(0)" tabindex="0" (keyup.enter)="setOption(2)"></a></span>
              </p>
            }
            @if (optionThreeText) {
              <p>
                <span [innerHTML]="optionThreeText | translate"></span>
                <span><a [innerHTML]="optionThreeLink | translate" (click)="setOption(3)" href="javascript:void(0)" tabindex="0" (keyup.enter)="setOption(3)"></a></span>
              </p>
            }
          </div>
        }
        @if (option === 1) {
          <div>
            <span [innerHTML]="optionOneSource | translate"></span>
          </div>
        }
        @if (option === 2) {
          <div>
            <span [innerHTML]="optionTwoSource | translate"></span>
          </div>
        }
        @if (option === 3) {
          <div>
            <span [innerHTML]="optionThreeSource | translate"></span>
          </div>
        }
      </div>
      <div class="modal-footer justify-content-evenly">
        @if (option !== 0) {
          <div class="col-12 col-lg-4 me-auto">
            <button type="button" class="btn d-block w-100 btn-default" (click)="reset()">
              <i class="fa fa-chevron-left" aria-hidden="true"></i> {{'GENERAL_REUSABLE.BACK_BUTTON' | translate}}
            </button>
          </div>
        }
        <div class="col-12 col-lg-4">
          <button type="button" class="btn d-block w-100 btn-primary" (click)="reset()" data-bs-dismiss="modal">{{buttonText | translate}}</button>
        </div>
      </div>
    </div><!-- /.modal-content -->
  </div><!-- /.modal-dialog -->
</div><!-- /.modal -->